import {BlackListedBins} from '../../types/interfaces/black-list';


export class FetchBlackListedBins {
  static readonly type = '[bins] Fetch All';

  constructor(public payload: BlackListedBins[]) {
  }
}
